<template>
  <div>
    <div
      v-if="!!status"
      class="biometry"
    >
      <recipient-biometry-status
        :status="status"
        :id="id"
      />
    </div>
    <recipient-info :data="info" />
    <recipient-bank-detail :data="bankDetail" />
    <div class="el-grid-list">
      <recipient-transfer-settings :data="transferSettings" />
      <recipient-anticipation-settings :data="anticipationSettings" />
    </div>
  </div>
</template>

<script>
import { KYC_STATUS_ENUM } from '@/enums/kyc.enum'

import RecipientInfo from './recipientInfo'
import RecipientBankDetail from './recipientBankDetail'
import RecipientTransferSettings from './recipientTransferSettings'
import RecipientAnticipationSettings from './recipientAnticipationSettings'

export default {
  components: {
    RecipientInfo,
    RecipientBankDetail,
    RecipientTransferSettings,
    RecipientAnticipationSettings,
    RecipientBiometryStatus: () =>
      import('../../RecipientsBiometry/biometry-status')
  },
  props: {
    id: {
      type: String,
      required: true
    },
    info: {
      type: Object,
      required: true
    },
    bankDetail: {
      type: Object,
      required: true
    },
    anticipationSettings: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      validation: value => Object.values(KYC_STATUS_ENUM).includes(value)
    },
    transferSettings: {
      type: Object,
      required: true
    }
  }
}
</script>
<style scoped>
@import '@stone-payments/jade-design-tokens/pagarme/space.css';
.biometry {
  margin-top: var(--global-space-300);
}
</style>
